import { render, staticRenderFns } from "./Grouping.vue?vue&type=template&id=ace71ee4&"
import script from "./Grouping.vue?vue&type=script&lang=js&"
export * from "./Grouping.vue?vue&type=script&lang=js&"
import style0 from "./Grouping.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports